module.exports = __webpack_public_path__ + "static/team_01-56c6f437ba73d163c3011190427de42d.png";